import './Loading.css';

function Loading({ color = '#fff', size = 13 }) {
  return (
    <div className="loading-ellipsis">
      <div style={{backgroundColor: color, width: size, height: size}}></div>
      <div style={{backgroundColor: color, width: size, height: size}}></div>
      <div style={{backgroundColor: color, width: size, height: size}}></div>
      <div style={{backgroundColor: color, width: size, height: size}}></div>
    </div>
  )
}

export default Loading;
